'use strict';

(function() {

  var toggle = document.querySelectorAll('[data-toggle="institution-feature-image-dropzone"]');

  function globalOptions() {
    Dropzone.autoDiscover = false;
  }

  function init(el) {
    var currentFile = undefined;
    var options = {
      url: $("#feature_image_upload").data("direct-upload-url"),
      autoProcessQueue: false,
      maxFiles: 1,
      acceptedFiles:"image/png,image/jpeg",
      previewsContainer: el.querySelector('.dz-preview'),
      previewTemplate: el.querySelector('.dz-preview').innerHTML,
      thumbnailHeight: 270,
      thumbnailWidth: 480,
      thumbnailMethod: 'crop',
      init: function() {
        if ($("#server_institution_feature_image").length) {
          var mockFile = { name: "Filename", size: 12345 };
          this.emit("addedfile", mockFile);
          this.emit("thumbnail", mockFile, $("#server_institution_feature_image").attr('src'));
          this.emit("complete", mockFile);
        }
        this.on('addedfile', function(file) {
          uploadFile(file);
          $(".dz-message").removeClass("border-danger");
          $("#InstitutionFeatureImageInvalidFeedback").remove();
        });
      }
    }

    // Clear preview
    el.querySelector('.dz-preview').innerHTML = '';

    // Init dropzone
    new Dropzone(el, options);
  }

  const uploadFile = (file) => {
    // your form needs the file_field direct_upload: true, which
    //  provides data-direct-upload-url
    const url = $("#feature_image_upload").data("direct-upload-url")
    const upload = new ActiveStorage.DirectUpload(file, url)
   
    upload.create((error, blob) => {
      if (error) {
        // Handle the error
      } else {
        // Add an appropriately-named hidden input to the form with a
        //  value of blob.signed_id so that the blob ids will be
        //  transmitted in the normal upload flow
        const hiddenField = document.createElement('input')
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("value", blob.signed_id);
        hiddenField.name = "feature_image_blob";
        document.querySelector('form').appendChild(hiddenField)
      }
    })
  }

  //
  // Events
  //

  if (typeof Dropzone !== 'undefined' && toggle) {
    globalOptions();

    [].forEach.call(toggle, function(el) {
      init(el);
    });
  }

})();